module.exports = __webpack_public_path__ + "static/media/bumba.7abc6cf2.jpeg";